// @ts-nocheck
import { TabDefinition } from "@insite/client-framework/Types/TabDefinition";
import { GreifFieldDefinition } from "@store/Framework/Types/FieldDefinition";
import cloneDeep from "lodash/cloneDeep";

/**
 *
 * Applies a tab to a set of fieldDefinitions
 *
 * @param tab The fieldDefinitions tab
 * @param fieldDefinitions The fieldDefinitions to apply the tab to.
 * @returns A clone of the given fieldDefinitions with the tab applied to.
 */
export default (tab: TabDefinition, fieldDefinitions: GreifFieldDefinition[]) => {
    if (!fieldDefinitions.length) {
        return [];
    }

    return cloneDeep(fieldDefinitions).map(x => {
        if (!x.tab) {
            x.tab = tab;
        }

        return x;
    });
};
